export enum Animations {
    'slide-top' = 'slide-top',
    'scale-in' = 'scale-in',
}
